import React, { useState } from 'react';
import { Popover, Box, Typography, Select, MenuItem, Button, Grid, FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';

const PopoverContainer = styled(Box)(({ theme }) => ({
  width: 600,
  padding: theme.spacing(3),
  borderRadius: '8px',
}));

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiInputLabel-root': {
    fontSize: '14px',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  '& .MuiSelect-select': {
    borderRadius: '4px',
  },
}));

const Label = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: theme.spacing(1),
}));

const FilterModal = ({ open, onClose, anchorEl }) => {
  const [filters, setFilters] = useState({
    claimTaken: 'Yes',
    welcomeCall: 'Yes',
    bdmStatus: 'Completed',
    accountingStatus: 'Completed',
    croStatus: 'Completed',
    amountStatus: 'Pending balance',
    renewalMonth: 'May',
    renewalYear: '2022',
    accountConfigures: 'Yes',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <PopoverContainer>
        <Typography variant="h6" gutterBottom>Filter</Typography>
        <Grid container spacing={3}>
          <Grid item xs={6}><Label>Claim Taken</Label><StyledFormControl fullWidth size="small"><Select name="claimTaken" value={filters.claimTaken} onChange={handleChange}><MenuItem value="Yes">Yes</MenuItem><MenuItem value="No">No</MenuItem></Select></StyledFormControl></Grid>
          <Grid item xs={6}><Label>Welcome Call</Label><StyledFormControl fullWidth size="small"><Select name="welcomeCall" value={filters.welcomeCall} onChange={handleChange}><MenuItem value="Yes">Yes</MenuItem><MenuItem value="No">No</MenuItem></Select></StyledFormControl></Grid>
          <Grid item xs={6}><Label>BDM Status</Label><StyledFormControl fullWidth size="small"><Select name="bdmStatus" value={filters.bdmStatus} onChange={handleChange}><MenuItem value="Completed">Completed</MenuItem><MenuItem value="Pending">Pending</MenuItem></Select></StyledFormControl></Grid>
          <Grid item xs={6}><Label>Accounting Status</Label><StyledFormControl fullWidth size="small"><Select name="accountingStatus" value={filters.accountingStatus} onChange={handleChange}><MenuItem value="Completed">Completed</MenuItem><MenuItem value="Pending">Pending</MenuItem></Select></StyledFormControl></Grid>
          <Grid item xs={6}><Label>CRO Status</Label><StyledFormControl fullWidth size="small"><Select name="croStatus" value={filters.croStatus} onChange={handleChange}><MenuItem value="Completed">Completed</MenuItem><MenuItem value="Pending">Pending</MenuItem></Select></StyledFormControl></Grid>
          <Grid item xs={6}><Label>Amount Status</Label><StyledFormControl fullWidth size="small"><Select name="amountStatus" value={filters.amountStatus} onChange={handleChange}><MenuItem value="Pending balance">Pending balance</MenuItem><MenuItem value="Paid">Paid</MenuItem></Select></StyledFormControl></Grid>
          <Grid item xs={6}><Label>Renewal Month</Label><StyledFormControl fullWidth size="small"><Select name="renewalMonth" value={filters.renewalMonth} onChange={handleChange}><MenuItem value="May">May</MenuItem><MenuItem value="June">June</MenuItem></Select></StyledFormControl></Grid>
          <Grid item xs={6}><Label>Renewal Year</Label><StyledFormControl fullWidth size="small"><Select name="renewalYear" value={filters.renewalYear} onChange={handleChange}><MenuItem value="2022">2022</MenuItem><MenuItem value="2023">2023</MenuItem></Select></StyledFormControl></Grid>
          <Grid item xs={6}><Label>Account Configures</Label><StyledFormControl fullWidth size="small"><Select name="accountConfigures" value={filters.accountConfigures} onChange={handleChange}><MenuItem value="Yes">Yes</MenuItem><MenuItem value="No">No</MenuItem></Select></StyledFormControl></Grid>
        </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 2 }}>
          <Button variant="outlined" color="error" onClick={onClose}>Reset</Button>
          <Button variant="contained">Apply</Button>
        </Box>
      </PopoverContainer>
    </Popover>
  );
};

export default FilterModal;
